import React from 'react';

import GlobalNav from './Navigation/GlobalNav';

function App() {
    return <>
        <GlobalNav />
    </>
}

export default App;